<div class="d-flex flex-wrap align-items-start mb-6">
  <label class="col-12 col-lg-4 col-form-label" [class.required]="required">{{ label }}</label>
  <div class="col-12 col-lg-8">
    <div class="mb-2" *ngIf="chipsListData && chipsListData.length > 0">
      <app-chips-legacy [chipsList]="chipsListData" [disabled]="disabled" (dataOutput)="handleDataOutput($event)"></app-chips-legacy>
    </div>
    <button
      type="button"
      [ngClass]="{
        'btn-outline': btnStyleOutline,
        'btn-outline--disabled': btnStyleDisabled
      }"
      class="btn px-4"
      (click)="handleOpenModalForm()"
      [disabled]="disabled"
      mat-button
      color="primary"
    >
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS" class="svg-icon svg-icon-2"></span>
      <span class="text-primary" [ngClass]="{ 'text-gray-300': btnStyleDisabled }">{{ ctaLabelOpenModalForm }}</span>
    </button>
  </div>
</div>

<app-modal-form #modalForm [modalConfig]="modalFormConfig" *ngIf="listbox_listItems$ | async">
  <div *ngIf="listbox_selectedItems.value.length && showChipsModal" class="mb-4">
    <app-chips-legacy [chipsList]="listbox_selectedItems.value" (dataOutput)="handleDataOutput($event)"></app-chips-legacy>
  </div>

  <ng-container *ngIf="listbox_listItems.value.length; else noDataTpl">
    <div class="multiselect-search mb-4">
      <div class="input-group">
        <input [formControl]="searchControl" [readOnly]="isLoading.value" class="form-control" ngDefaultControl placeholder="Silahkan cari {{ searchLabel }} disini" type="text" />
        <span class="input-group-text">
          <span [inlineSVG]="'./assets/media/icons/ic_search.svg'" class="svg-icon svg-icon-2"></span>
        </span>
      </div>
    </div>

    <div class="form-check" *ngIf="useIndeterminateCheckbox">
      <input #checkboxAll id="checkAll" type="checkbox" class="form-check-input cursor-pointer" (change)="handleCheckAll($event)" />
      <label for="checkAll" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize fw-bolder">
        {{ labelCheckAll }}
      </label>
    </div>

    <div class="multiselect-list mh-200px overflow-auto mb-4">
      <div *ngFor="let item of listbox_listItems.value | filter : searchControl.value" class="form-check my-6 text-capitalize">
        <input class="form-check-input cursor-pointer" type="checkbox" id="flexCheckDefault-{{ item.id }}" (change)="handleChangeSelection()" [(ngModel)]="item.selected" />

        <ng-container *ngIf="item['status_value']; else defaultLabel">
          <div class="d-flex align-items-center">
            <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">
              {{ item.name | lowercase }}
            </label>
            <span class="ms-4 badge badge-bg badge__status badge__status--{{ item['status'] }}">
              {{ item['status_value'] }}
            </span>
          </div>
        </ng-container>

        <ng-template #defaultLabel>
          <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">
            {{ item.name | lowercase }}
          </label>
        </ng-template>

        <span *ngIf="haveDescription">
          <br />
          <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">{{ item[descriptionKey] | lowercase }}</label>
        </span>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-primary" (click)="handleAddChipsList()" [disabled]="!listbox_selectedItems.value.length">
        {{ ctaLabelAddItems }}
      </button>
    </div>
  </ng-container>

  <ng-template #noDataTpl>
    <p class="px-7">Tidak ada data...</p>
  </ng-template>
</app-modal-form>
